import { IAppState } from '../../redux';
import { IRecommendedServicePackage } from '../../redux/reducers';
import { selectActiveService } from './selectActiveService';

export const selectActiveRecommendedPackage = (state: IAppState): IRecommendedServicePackage | null => {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return null;
  }

  const {
    publishOptions: { recommendedPackages, selectedRecommendedPackageId },
  } = selectedService;

  if (!selectedRecommendedPackageId) {
    return null;
  }

  return recommendedPackages[selectedRecommendedPackageId];
};
